import { useEffect } from 'react'
import { supabase } from '../supabaseClient'
import { EncoderEvent, PendingSubmission } from '../components/Reader/Encoder/types'

export function useEncoderRealtime(
    encodingId: string,
    currentSubmissionId: string | null,
    dispatch: React.Dispatch<EncoderEvent>
): void {
    useEffect(() => {
        const channel = supabase.channel(`encoder-${encodingId}`)

        channel
            .on(
                'postgres_changes',
                {
                    event: 'INSERT',
                    schema: 'public',
                    table: 'etcbc_encoding_pendingapproval',
                },
                (payload) => {
                    // Only handle if it's for this encoding
                    if (payload.new.encoding === encodingId) {
                        dispatch({
                            type: 'EXTERNAL_SUBMISSION_RECEIVED',
                            submission: payload.new as PendingSubmission,
                        })
                    }
                }
            )
            .on(
                'postgres_changes',
                {
                    event: 'DELETE',
                    schema: 'public',
                    table: 'etcbc_encoding_pendingapproval',
                },
                (payload) => {
                    // Only handle if it's the current submission
                    if (payload.old.id === currentSubmissionId) {
                        dispatch({ type: 'EXTERNAL_SUBMISSION_DELETED' })
                    }
                }
            )
            .subscribe()

        return () => {
            supabase.removeChannel(channel)
        }
    }, [encodingId, currentSubmissionId, dispatch])
}
